var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formGroup"},[_c('div',{staticClass:"btn btnFull",style:(_vm.setDetailStyle(_vm.item.detail)),on:{"focusout":function($event){return _vm.updateCITE(_vm.item)}}},[_c('CITEditor',{attrs:{"model":_vm.item.value,"toolbarOption":_vm.textOption,"lang":_vm.activeLang}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }